import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'How is my voting power calculated?',
  descriptionFirst:
    'Your voting power for this proposal is equivalent to your SSAP balance plus any delegated voting power you had at the moment the proposal was created.',
  descriptionSecond: 'Therefore, it might be different from your current voting power.',
});
